// src/modules/reminders/ReminderIndex.tsx

import React from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { ReminderForm } from './ReminderForm';
import ReminderList  from './ReminderList';
import AboutSection from '../AboutSection';
import ReminderDashboard from './ReminderDashboard'; // Optional: you can create this or remove
// import ReminderBulkUpload from './ReminderBulkUpload'; // Optional for bulk upload feature

const isAdmin = true;

const ReminderFormWrapper: React.FC = () => {
  const location = useLocation();
  const pathname = location.pathname;

  let mode: 'create' | 'edit' | 'view' = 'view';
  if (pathname.endsWith('/create')) mode = 'create';
  else if (pathname.endsWith('/edit')) mode = 'edit';

  return (
    <div className="min-h-screen bg-gray-100 flex flex-col w-full p-2">
      <AboutSection title={`Reminders - ${mode}`} iconName="alarm-clock" />
      <ReminderForm mode={mode} />
    </div>
  );
};

const RemindersModule: React.FC = () => {
  if (!isAdmin) return <Navigate to="/unauthorized" />;

  return (
    <Routes>
      <Route index element={<ReminderDashboard />} /> {/* Optional */}
      <Route path="list" element={<ReminderList />} />
      <Route path="create" element={<ReminderFormWrapper />} />
      <Route path=":id" element={<ReminderFormWrapper />} />
      <Route path=":id/edit" element={<ReminderFormWrapper />} />
      {/* <Route path="bulk-upload" element={<ReminderBulkUpload />} /> */}
    </Routes>
  );
};

export default RemindersModule;